import React from "react";

const Heading = (props) => {
    return (
        <h2 className='text-center mt-3 heading-title'>
            {props.title}
        </h2>
    )
}

export default Heading;